import type { ServiceConfig } from './types.js';

/**
 * The six ECS callers. The Serverless/CDK half lands with R1b, whose jobs are shaped differently.
 *
 * westWorkspaces is a validation list, not a discovery list: a workspace parsed out of a job name
 * that is not here is treated as a parse failure rather than a new service.
 */
export const SERVICES: readonly ServiceConfig[] = [
  { repo: 'ultron', workflow: 'deployment-ecs.yml', westWorkspaces: ['st-en-cb-ultron-ecs_us-west-2'] },
  {
    repo: 'restore-service',
    workflow: 'deployment-ecs.yml',
    westWorkspaces: [
      'st-en-cb-restore-ecs_us-west-2',
      'st-en-cb-restore-copy-ecs_us-west-2',
      'st-en-cb-restore-sync-ecs_us-west-2',
    ],
  },
  { repo: 'argus', workflow: 'deployment-ecs.yml', westWorkspaces: ['st-argus-en_us-west-2'] },
  { repo: 'nimbus', workflow: 'deployment-ecs.yml', westWorkspaces: ['st-nimbus-en_us-west-2'] },
  { repo: 'charon', workflow: 'deployment-ecs.yml', westWorkspaces: ['st-charon-en_us-west-2'] },
  { repo: 'galactus', workflow: 'deployment.yml', westWorkspaces: ['st-galactus-en-ecs_us-west-2'] },
];
